import { useState, useEffect } from 'react'

import useInterval from 'hooks/useInterval/useInterval'

const COUNTDOWN_INTERVAL = 1000

const useCountdownTimer = timeInSeconds => {
    const [timeLeft, setTimeLeft] = useState(timeInSeconds)
    const [timerActive, setTimerActive] = useState(false)

    // function to start the countdown timer
    const startCountdown = () => {
        setTimerActive(true)
    }

    const stopCountdown = () => {
        setTimerActive(false)
        setTimeLeft(timeInSeconds)
    }

    useInterval(
        () => {
            if (timerActive) {
                setTimeLeft(timeLeft - 1)
            }
        },
        !timeLeft ? null : COUNTDOWN_INTERVAL
    )

    useEffect(() => {
        if (!timeLeft) {
            stopCountdown()
            return
        }
    }, [timeLeft, timerActive])

    return {
        // to always return integer in 2 digits 0:01, 0:09, 0:29 etc
        timeLeft: `0:${timeLeft.toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false,
        })}`,
        _timeLeft: timeLeft,
        timerActive,
        startCountdown,
        stopCountdown,
    }
}

export default useCountdownTimer
